const GOLDEN_ANGLE = Math.PI * (3 - Math.sqrt(5))

/** Below this a hub counts as sitting on its host, and the direction to push it in is arbitrary. */
const MIN_OFFSET = 1e-3

function coordinate (fixed, free) {
	return Number.isFinite(fixed) ? fixed : free
}

/** Keeps every hub on a ring around its own host, so a hub can never come to rest on top of it. */
export default function (orbit) {
	let hubs = []
	let hosts = new Map()

	function f () {
		hubs.forEach((hub, i) => {
			const host = hosts.get(hub.hostId)
			if (!host) return
			const hostX = coordinate(host.fx, host.x)
			const hostY = coordinate(host.fy, host.y)
			if (!Number.isFinite(hostX) || !Number.isFinite(hostY)) return
			const dx = hub.x - hostX
			const dy = hub.y - hostY
			const l = Math.sqrt(dx * dx + dy * dy)
			const placed = Number.isFinite(l) && l > MIN_OFFSET
			// a deterministic spoke rather than a random nudge, so hubs that start out stacked
			// spread instead of drifting off together
			const angle = i * GOLDEN_ANGLE
			const ux = placed ? dx / l : Math.cos(angle)
			const uy = placed ? dy / l : Math.sin(angle)
			hub.x = hostX + ux * orbit
			hub.y = hostY + uy * orbit
		})
	}

	f.initialize = function (nodes) {
		hubs = nodes.filter((n) => n.hostId)
		hosts = new Map(nodes.map((n) => [ n.id, n ]))
	}

	return f
}
